import { makeAwsSignedRequest } from '../ApiService';

export interface PendingDeltaEntry {
    label: string;
    startCount: number;
    endCount: number;
    absoluteChange: number;
    netNewCount: number;
    netRecoveredCount: number;
    netNewSampleRefundIds: string[];
    netRecoveredSampleRefundIds: string[];
}

export interface PendingDeltaResponse {
    generatedAt: string;
    timeWindow: string;
    clientId: string;
    requestedWindowStart?: string | null;
    requestedWindowEnd?: string | null;
    processorWindowStart?: string | null;
    processorWindowEnd?: string | null;
    clientWindowStart?: string | null;
    clientWindowEnd?: string | null;
    processorSnapshotsAnalyzed: number;
    clientSnapshotsAnalyzed: number;
    processors: PendingDeltaEntry[];
    clients: PendingDeltaEntry[];
}

export const PendingDeltaApi = {
    getPendingDeltas: (
        stage: string,
        realm: string,
        timeWindow: string,
        clientId: string,
    ): Promise<PendingDeltaResponse> =>
        makeAwsSignedRequest(stage, realm, `tracker/pending-deltas?timeWindow=${encodeURIComponent(timeWindow)}&clientId=${encodeURIComponent(clientId)}`),
};
